import { wsService } from '../services/websocketApi.ts';
import { store } from '../store';
import { addMessage, updateConfig } from '../features/globalSlice.ts';
import { Message } from '../services/websocketApi';

const topics = ['chat-room-1', 'alerts', 'config-topic'];

const listener = (msg: any) => {
    // Handle different message types
    
    // User updates (action: "updated", user: {...}) - silently ignore, handled by useChannelQuery
    if (msg?.action === 'updated' || msg?.action === 'created' || msg?.action === 'deleted') {
        return;
    }
    
    // Regular messages must have a message property
    if (!msg || !msg.message) {
        console.warn('Received invalid WebSocket message:', msg);
        return;
    }
    
    if (msg.message.includes('config:')) {
        const topic = 'config-topic';
        const newConfig = JSON.parse(msg.message.replace('config:', ''));
        store.dispatch(updateConfig({ topic, config: newConfig }));
    } else {
        const topic = msg.id?.includes('alert') ? 'alerts' : 'chat-room-1';
        store.dispatch(addMessage({ topic, message: msg }));
    }
};

// Subscribe globally to all topics
topics.forEach((topic) => wsService.subscribe(listener, topic));
